// Allergie e intolleranze alimentari più comuni (dati curati, offline).
// Fonti: linee guida EAACI, WAO, NIAID e revisioni indicizzate su PubMed.
export const ALLERGIES = [
  {
    value: "lattosio",
    label: "Intolleranza al Lattosio",
    tipo: "Intolleranza",
    descr: "Deficit di lattasi con sintomi gastrointestinali dopo assunzione di lattosio.",
    escludere: ["Latte vaccino", "Panna e besciamella", "Gelato a base di latte", "Formaggi freschi ricchi di lattosio (ricotta, mozzarella in eccesso)"],
    attenzione: ["Lattosio nascosto in prodotti da forno, salumi, insaccati", "Farmaci e integratori (eccipiente)", "Purè e piatti pronti"],
    consigli: ["Preferire prodotti 'senza lattosio' o bevande vegetali fortificate in calcio.", "I formaggi stagionati (grana, parmigiano) sono naturalmente poveri di lattosio.", "Garantire l'apporto di calcio/vitamina D da fonti alternative.", "Enzima lattasi orale se necessario, su indicazione medica."],
    refs: ["Misselwitz B. et al., Gut 2019 (PMID: 31563877)"],
  },
  {
    value: "glutine_celiachia",
    label: "Celiachia / Sensibilità al Glutine",
    tipo: "Allergia/Autoimmune",
    descr: "Reazione immunitaria al glutine; nella celiachia richiede dieta senza glutine a vita.",
    escludere: ["Frumento, orzo, segale, farro, kamut", "Pane, pasta, pizza non certificati", "Birra e malto d'orzo"],
    attenzione: ["Cross-contaminazione in cucina (utensili, friggitrici)", "Glutine nascosto in salse, dadi, salumi", "Avena non certificata"],
    consigli: ["Usare esclusivamente prodotti certificati senza glutine.", "Separare utensili e superfici per evitare contaminazioni.", "Monitorare carenze di ferro, folati, vitamina D, calcio.", "Preferire alimenti naturalmente privi di glutine (riso, mais, patate, legumi)."],
    refs: ["ACG Celiac Disease Guideline 2023 (PMID: 36602836)"],
  },
  {
    value: "latte_vaccino",
    label: "Allergia alle Proteine del Latte Vaccino",
    tipo: "Allergia",
    descr: "Risposta immunitaria (spesso IgE) alle proteine del latte (caseina, sieroproteine).",
    escludere: ["Latte e derivati di tutti i mammiferi", "Formaggi, yogurt, burro, panna", "Prodotti con caseina/caseinato/siero di latte"],
    attenzione: ["Caseinati in salumi, prodotti da forno, cioccolato", "Aromi e 'latte in polvere'", "Ambiente scolastico/ristorazione"],
    consigli: ["Diversa dall'intolleranza al lattosio: qui vanno escluse le PROTEINE.", "Bevande vegetali fortificate in calcio come alternativa.", "Portare adrenalina autoiniettabile se prescritta.", "Leggere sempre le etichette (allergene evidenziato per legge)."],
    refs: ["EAACI Food Allergy Guidelines", "NIAID Guidelines (PMID: 21134576)"],
  },
  {
    value: "uovo",
    label: "Allergia all'Uovo",
    tipo: "Allergia",
    descr: "Allergia IgE-mediata alle proteine dell'uovo (albume soprattutto).",
    escludere: ["Uova intere, albume e tuorlo", "Frittate, maionese, dolci con uovo", "Pasta all'uovo"],
    attenzione: ["Albumina/lisozima in prodotti da forno e alcuni vini", "Alcuni vaccini (valutazione medica)", "Panature"],
    consigli: ["Sostituti dell'uovo in cucina (semi di lino, aquafaba).", "Leggere le etichette per lecitina/albumina.", "Piano di emergenza con adrenalina se prescritto."],
    refs: ["EAACI Food Allergy Guidelines"],
  },
  {
    value: "arachidi",
    label: "Allergia alle Arachidi",
    tipo: "Allergia",
    descr: "Allergia potenzialmente grave, rischio di anafilassi.",
    escludere: ["Arachidi e burro di arachidi", "Snack e dolci con arachidi", "Oli di arachide non raffinati"],
    attenzione: ["Cross-contaminazione (prodotti 'può contenere')", "Cucina etnica (asiatica, africana)", "Salse (satay)"],
    consigli: ["Portare SEMPRE adrenalina autoiniettabile.", "Evitare cibi con avvertenza di tracce.", "Informare scuola/ristoranti dell'allergia."],
    refs: ["LEAP Study, NEJM 2015 (PMID: 25705822)", "NIAID Peanut Guidelines"],
  },
  {
    value: "frutta_guscio",
    label: "Allergia alla Frutta a Guscio",
    tipo: "Allergia",
    descr: "Allergia a noci, mandorle, nocciole, anacardi, pistacchi, ecc.",
    escludere: ["Noci, mandorle, nocciole, anacardi, pistacchi", "Creme e farine di frutta secca", "Dolci e pesti con frutta a guscio"],
    attenzione: ["Cross-contaminazione in prodotti da forno", "Oli e aromi", "Cosmetici e integratori"],
    consigli: ["Identificare con il medico quali specie evitare.", "Adrenalina autoiniettabile se prescritta.", "Leggere sempre le etichette."],
    refs: ["EAACI Food Allergy Guidelines"],
  },
  {
    value: "crostacei_molluschi",
    label: "Allergia a Crostacei / Molluschi",
    tipo: "Allergia",
    descr: "Allergia alla tropomiosina; spesso persistente in età adulta.",
    escludere: ["Gamberi, granchi, aragoste", "Cozze, vongole, calamari, polpo", "Salse e brodi di pesce/crostacei"],
    attenzione: ["Cross-contaminazione in pescherie e fritture miste", "Surimi", "Integratori di glucosamina (da crostacei)"],
    consigli: ["Attenzione ai vapori di cottura (possibili reazioni respiratorie).", "Adrenalina se prescritta.", "Segnalare l'allergia al ristorante."],
    refs: ["EAACI Food Allergy Guidelines"],
  },
  {
    value: "pesce",
    label: "Allergia al Pesce",
    tipo: "Allergia",
    descr: "Allergia alle parvalbumine del pesce.",
    escludere: ["Tutti i pesci (salvo diversa indicazione)", "Salse a base di pesce (Worcester, colatura)", "Surimi"],
    attenzione: ["Cross-contaminazione con crostacei", "Vapori di cottura", "Gelatine e integratori di omega-3 da pesce"],
    consigli: ["Fonte alternativa di omega-3 (semi di lino, noci, alghe).", "Adrenalina se prescritta."],
    refs: ["EAACI Food Allergy Guidelines"],
  },
  {
    value: "soia",
    label: "Allergia alla Soia",
    tipo: "Allergia",
    descr: "Allergia alle proteine della soia, comune nei bambini.",
    escludere: ["Soia, edamame, tofu, tempeh", "Latte e yogurt di soia", "Salsa di soia, miso"],
    attenzione: ["Lecitina di soia (E322) in molti prodotti", "Proteine vegetali testurizzate", "Prodotti da forno e cioccolato"],
    consigli: ["Leggere le etichette (allergene evidenziato).", "Alternative proteiche vegetali diverse dalla soia."],
    refs: ["EAACI Food Allergy Guidelines"],
  },
  {
    value: "nichel",
    label: "Allergia/Sensibilità al Nichel (SNAS)",
    tipo: "Intolleranza/Allergia",
    descr: "Sindrome sistemica da nichel con sintomi cutanei e gastrointestinali.",
    escludere: ["Cibi molto ricchi di nichel: cacao/cioccolato", "Frutta secca e semi", "Legumi (in fase acuta)", "Pomodoro in conserva, molluschi"],
    attenzione: ["Cottura in pentole non idonee (acciaio scadente)", "Cibi in scatola", "Acqua stagnante nei tubi al mattino"],
    consigli: ["Dieta a basso contenuto di nichel a fasi, poi reintroduzione guidata.", "Preferire pentolame in vetro/ceramica.", "Percorso con allergologo/nutrizionista."],
    refs: ["Rizzi A. et al., Systemic Nickel Allergy Syndrome reviews"],
  },
  {
    value: "istamina",
    label: "Intolleranza all'Istamina",
    tipo: "Intolleranza",
    descr: "Ridotta attività dell'enzima DAO con sintomi dopo cibi ricchi di istamina.",
    escludere: ["Formaggi stagionati", "Salumi e pesce conservato/affumicato", "Vino e birra", "Alimenti fermentati (crauti)"],
    attenzione: ["Pesce non freschissimo (sgombro, tonno)", "Pomodoro, spinaci, melanzane", "Additivi liberatori di istamina"],
    consigli: ["Consumare alimenti freschissimi e ben conservati.", "Evitare avanzi conservati a lungo.", "Percorso a fasi con specialista."],
    refs: ["Comas-Basté O. et al., Biomolecules 2020 (PMID: 32824107)"],
  },
  {
    value: "fruttosio",
    label: "Malassorbimento del Fruttosio",
    tipo: "Intolleranza",
    descr: "Ridotto assorbimento intestinale del fruttosio con sintomi gastrointestinali.",
    escludere: ["Sciroppo di glucosio-fruttosio", "Succhi e bibite zuccherate", "Miele", "Dolcificanti polioli (sorbitolo)"],
    attenzione: ["Frutta molto ricca di fruttosio (mela, pera, uva, fichi)", "Prodotti 'senza zucchero' con polioli", "Frutta secca/disidratata"],
    consigli: ["Approccio low-FODMAP a fasi.", "Il glucosio favorisce l'assorbimento del fruttosio (rapporto favorevole).", "Percorso con nutrizionista."],
    refs: ["Fedewa A., Rao SS. Curr Gastroenterol Rep 2014 (PMID: 24357350)"],
  },
];
